import helper from 'helpers/steinerHelper';
    
export const actionTypes = helper.createActionTypes('monitorRichiesteCrm');
export const actions = helper.createActions('monitorRichiesteCrm', actionTypes);